export const supportedDevicePixelRatios = [1, 2, 3];
// when fullWidth is true we supply a lot of images to the browser so it can choose the best one as the size is dynamic
export const fullWidthRatios = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
//# sourceMappingURL=supportedDevicePixelRatios.js.map